

var _index = require('xo-models/src/shippingMethod/index');

var _logger = require('xo-beaver/dist/logger');

var shippingTaxModel = _index.$ShippingMethodModel.instance();

module.exports = {
    // gets the shipping profile of the merchant for non US. Address will not be passed to profile shipping calculator
    getShippingCharges: function getShippingCharges(merchantId, itemList, noShippingParam) {
        return shippingTaxModel.action('', {
            data: {
                merchant_id: merchantId,
                item_list: itemList,
                tax_computation_required: false
            },
            success: function success(response) {
                if (response && response.charges && response.charges[0]) {
                    return {
                        noShippingParam: noShippingParam,
                        profileOverride: response && response.profile_override_allowed,
                        value: response.charges[0].shipping_charge.shipping_amount.value / 100.0
                    };
                } else {
                    return {
                        profileShippingError: true
                    };
                }
            },
            contingencies: {
                DEFAULT: function DEFAULT(errorName) {
                    _logger.$logger.info('get_profile_shipping_error', errorName);
                    return {
                        profileShippingError: true
                    };
                }
            }
        });
    }
};

_index.$ShippingMethodModel;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/shippingUtil.js
// module id = ./pages/xo-shoppingcart/shippingUtil.js
// module chunks = 1